import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  convertDateYYYYMMDD,
  dateFormate,
  decryptedAdminID,
  MyModal,
} from "../../../../utility";
import { useDispatch } from "react-redux";
import { AdminAnalyticsActions } from "../../../../redux-store/store";
import ModalContainer from "../../../../components/modal_popup";
import { FormControl, Menu, MenuItem, TextField } from "@mui/material";
import { BiFilterAlt } from "react-icons/bi";
import { AiOutlineClose } from "react-icons/ai";
import { GetAllAdminDetails } from "../../../../apiServices";

function AdminAnalyticsFilter() {
  // const analyticsFilter = useSelector(
  //   (state) => state.AdminAnalytics.analyticsFilter
  // );
  const adminAnalyticsFilter = useSelector(
    (state) => state.AdminAnalytics.analyticsFilter
  );
  const adminAnalyticsFilterType = useSelector(
    (state) => state.AdminAnalytics.analyticsFilter.dateFilterType
  );

  const adminAnalyticsFilterAdmin = useSelector(
    (state) => state.AdminAnalytics.analyticsFilter.adminId
  );

  const dispatch = useDispatch();
  const isTeamLeader = localStorage.getItem("teamLeader");
  const adminDetailsRole = useSelector((state) => state.adminDetails);
  let isSuperAdmin = adminDetailsRole.roleID == 1;
  const [openFilter, setopenFilter] = useState(false);
  const initialObject = {
    adminId: adminAnalyticsFilterAdmin,
    startDate: adminAnalyticsFilter.startDate,
    endDate: adminAnalyticsFilter.endDate,
  };
  const [dataFilter, setDataFilter] = useState(initialObject);
  const [adminList, setAdminList] = useState([]);
  const [dateRange, setDateRange] = useState({
    start: adminAnalyticsFilter.startDate,
    end: adminAnalyticsFilter.endDate,
    dateFilterType: adminAnalyticsFilterType,
  });
  const [validationErrors, setValidationErrors] = useState({
    start: false,
    end: false,
  });
  const [showCustom, setShowCustom] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const handleClose = () => {
    setAnchorEl(null);
  };
  useEffect(() => {
    console.log(adminAnalyticsFilter, "kkk");
  }, [
    adminAnalyticsFilter,
    adminAnalyticsFilterType,
    adminAnalyticsFilterAdmin,
  ]);
  useEffect(() => {
    const teamLeaderId = localStorage.getItem("teamLeaderId");
    const teamLeader = localStorage.getItem("teamLeader");
    GetAllAdminDetails()
      .then((data) => {
        const withoutleaderID = teamLeaderId;
        const withoutleader = teamLeader;
        const activeAdmins = data.filter((item) =>
          !item.Deactived &&
          item.Module !== "Developer" &&
          withoutleader == "true"
            ? item.id != withoutleaderID
            : item.id
        );
        setAdminList(activeAdmins);
      })
      .catch(() => {
        alert("Something Went wrong");
      });
    console.log(adminAnalyticsFilter.dateFilterType);
  }, []);

  const handleDateSelect = (val) => {
    const today = new Date();
    let startDate, endDate;

    if (val === "currentMonth") {
      startDate = new Date(today.getFullYear(), today.getMonth(), 2);
      endDate = today;
      setDateRange((prev) => ({
        ...prev,
        dateFilterType: "Current Month",
        start: startDate.toISOString().split("T")[0],
        end: endDate.toISOString().split("T")[0],
      }));
    } else if (val === "today") {
      const dateStr = today.toISOString().split("T")[0];
      setDateRange((prev) => ({
        ...prev,
        dateFilterType: "Today",
        start: dateStr,
        end: dateStr,
      }));
    } else if (val === "yesterday") {
      const yesterday = new Date(today);
      yesterday.setDate(today.getDate() - 1);
      const dateStr = yesterday.toISOString().split("T")[0];
      setDateRange((prev) => ({
        ...prev,
        dateFilterType: "Yesterday",
        start: dateStr,
        end: dateStr,
      }));
    } else if (val === "lastMonth") {
      startDate = new Date(today.getFullYear(), today.getMonth() - 1, 2);
      endDate = new Date(today.getFullYear(), today.getMonth(), 0);
      setDateRange((prev) => ({
        ...prev,
        dateFilterType: "Last Month",
        start: startDate.toISOString().split("T")[0],
        end: endDate.toISOString().split("T")[0],
      }));
    } else if (val === "custom") {
      setShowCustom(true);
    }

    setAnchorEl(null);
  };

  const handleCustomDate = (value, type) => {
    const val = value.target.value;

    if (type === "startDate") {
      setDateRange((prev) => ({
        ...prev,
        start: val,
        dateFilterType: "custom",
      }));
      setValidationErrors((prev) => ({
        ...prev,
        start: false,
      }));
    } else {
      setDateRange((prev) => ({
        ...prev,
        end: val,
        dateFilterType: "custom",
      }));
      setValidationErrors((prev) => ({
        ...prev,
        end: false,
      }));
    }
  };

  const isFormValid = () => {
    const isValid = dateRange.start && dateRange.end;

    if (!dateRange.start) {
      setValidationErrors((prev) => ({
        ...prev,
        start: true,
      }));
    }

    if (!dateRange.end) {
      setValidationErrors((prev) => ({
        ...prev,
        end: true,
      }));
    }

    return isValid;
  };

  const handleApply = (e) => {
    e.preventDefault();

    if (isFormValid()) {
      setValidationErrors({
        start: false,
        end: false,
      });
      setShowCustom(false);
    }
  };

  function handleFieldChange(field, value) {
    switch (field) {
      case "mobileNumber":
        // Check if the value is numeric before updating the state
        if (/^\d*$/.test(value) || value === "") {
          setDataFilter((prev) => ({ ...prev, [field]: value }));
        }
        break;

      default:
        setDataFilter((prev) => ({ ...prev, [field]: value }));
        break;
    }
  }
  const handleClearAll = () => {
    setDateRange({
      start: null,
      end: null,
      dateFilterType: "Today",
    });
    setDataFilter({
      adminId: isSuperAdmin ? -1 : decryptedAdminID(),
    });
    dispatch(
      AdminAnalyticsActions.setAnalticsFilter({
        ...initialObject,
        startDate: dateFormate(new Date()),
        endDate: dateFormate(new Date()),
      })
    );
    // setSelectedFilters(null);
  };
  const handleSubmit = (e) => {
    e.preventDefault();

    dispatch(
      AdminAnalyticsActions.setAnalticsFilter({
        ...dataFilter,
        startDate: dateRange.start || adminAnalyticsFilter.startDate,
        endDate: dateRange.end || adminAnalyticsFilter.endDate,
        dateFilterType: dateRange.dateFilterType || "",
      })
    );
    // console.log("Filter Data to be dispatched:", filters);

    setopenFilter(false);
  };
  const handleAssignToChange = (e) => {
    const { value, name } = e.target;
    console.log(value, name);

    if (value === "myTeam") {
      const assignTo = parseInt(decryptedAdminID());

      setDataFilter((prev) => ({
        ...prev,
        //   myTeam: true,
        adminId: assignTo,
      }));
    } else if (value === "-1") {
      setDataFilter((prev) => ({
        ...prev,
        //   myTeam: false,
        adminId: -1, // Convert "true" to null
      }));
    } else {
      setDataFilter((prev) => ({
        ...prev,
        //   myTeam: false,
        adminId: value, // Assign selected admin ID
      }));
    }
  };
  return (
    <div>
      <div
        className={`d-flex align-items-center btn btn-success`}
        variant="contained"
        onClick={() => setopenFilter(true)}
      >
        <BiFilterAlt />
        <p
          style={{
            //   backgroundColor: showRedDot ? "red" : "transparent",
            width: "8px",
            height: "8px",
            borderRadius: "50%",
          }}
        ></p>
        Filter
      </div>
      {openFilter && (
        <>
          <MyModal>
            <ModalContainer
              zIndex={1005}
              childComponent={
                <>
                  <div style={{ width: 400 }}>
                    <div className="d-flex align-items-center justify-content-between">
                      <div>
                        <b>Filter</b>
                      </div>
                      <div
                        className="btn btn-danger"
                        onClick={() => {
                          setopenFilter(false);
                        }}
                      >
                        <AiOutlineClose />
                      </div>
                    </div>
                  </div>
                  <FormControl variant="outlined" fullWidth>
                    <TextField
                      label="Custom Date"
                      value={dateRange.dateFilterType}
                      aria-controls={anchorEl ? "basic-menu" : undefined}
                      aria-haspopup="true"
                      aria-expanded={anchorEl ? "true" : undefined}
                      onClick={(e) => setAnchorEl(e.currentTarget)}
                      className="mt-2"
                    />
                    <Menu
                      id="basic-menu"
                      anchorEl={anchorEl}
                      open={Boolean(anchorEl)}
                      onClose={handleClose}
                      MenuListProps={{
                        "aria-labelledby": "basic-button",
                      }}
                      // defaultValue={"Today"}
                    >
                      {" "}
                      <MenuItem onClick={() => handleDateSelect("today")}>
                        Today
                      </MenuItem>
                      <MenuItem onClick={() => handleDateSelect("yesterday")}>
                        Yesterday
                      </MenuItem>
                      <MenuItem
                        onClick={() => handleDateSelect("currentMonth")}
                      >
                        Current Month
                      </MenuItem>
                      <MenuItem onClick={() => handleDateSelect("lastMonth")}>
                        Last Month
                      </MenuItem>
                      <MenuItem onClick={() => handleDateSelect("custom")}>
                        Custom Date/Month
                      </MenuItem>
                    </Menu>
                  </FormControl>
                  {showCustom && (
                    <MyModal>
                      <ModalContainer
                        zIndex={1005}
                        childComponent={
                          <div style={{ minWidth: "400px", width: "auto" }}>
                            <form onSubmit={handleApply}>
                              <p className="text-center">Select Custom Date</p>
                              <div className="mt-2">
                                <label htmlFor="start">From</label>
                                <input
                                  className={`form-control ${
                                    validationErrors.start ? "is-invalid" : ""
                                  }`}
                                  type="date"
                                  id="start"
                                  onChange={(value) =>
                                    handleCustomDate(value, "startDate")
                                  }
                                  min="2020-01-01"
                                  max={new Date().toISOString().split("T")[0]}
                                  value={dateRange.start}
                                />
                                {validationErrors.start && (
                                  <div className="invalid-feedback">
                                    Start date is required.
                                  </div>
                                )}
                              </div>
                              <div className="mt-2">
                                <label htmlFor="end">To</label>
                                <input
                                  className={`form-control ${
                                    validationErrors.end ? "is-invalid" : ""
                                  }`}
                                  type="date"
                                  id="end"
                                  onChange={(value) =>
                                    handleCustomDate(value, "endDate")
                                  }
                                  min="2020-01-01"
                                  max={new Date().toISOString().split("T")[0]}
                                  value={dateRange.end}
                                />
                                {validationErrors.end && (
                                  <div className="invalid-feedback">
                                    End date is required.
                                  </div>
                                )}
                              </div>
                              <div className="d-flex justify-content-end mt-3 ">
                                <button
                                  onClick={() => {
                                    setValidationErrors({
                                      start: false,
                                      end: false,
                                    });
                                    setShowCustom(false);
                                  }}
                                  style={{
                                    backgroundColor: "#b2261c",
                                  }}
                                  className="btn rounded-pill text-white px-4  me-2"
                                >
                                  Close
                                </button>
                                <button
                                  onClick={handleApply}
                                  // color="primary"
                                  className="btn rounded-pill text-white px-4"
                                  style={{
                                    backgroundColor: "#169C50",
                                  }}
                                >
                                  Apply
                                </button>
                              </div>
                            </form>
                          </div>
                        }
                      />
                    </MyModal>
                  )}
                  {adminList && isSuperAdmin && (
                    <TextField
                      // onChange={(e) =>
                      //   handleFieldChange("assignTo", e.target.value)
                      // }
                      onChange={(e) => handleAssignToChange(e)}
                      name="AssignedTo"
                      id="AssignedTo"
                      className="form-control mt-3"
                      select
                      label="Assigned To"
                      value={dataFilter.adminId}
                      defaultValue={dataFilter.adminId}
                    >
                      <MenuItem value={-1}>ALL</MenuItem>
                      {adminList.map((el) => (
                        <MenuItem key={el.id} value={el.id}>
                          {el.userName}
                        </MenuItem>
                      ))}
                    </TextField>
                  )}
                  <div className="d-flex justify-content-end align-items-center gap-2 mt-2">
                    <button
                      type="button"
                      className="btn btn-danger"
                      onClick={handleClearAll}
                      sx={{ mt: 2 }}
                    >
                      Clear All
                    </button>
                    <button
                      type="submit"
                      className="btn btn-success"
                      sx={{ mt: 2, mr: 1 }}
                      onClick={handleSubmit}
                    >
                      Apply Filter
                    </button>
                  </div>
                </>
              }
            />
          </MyModal>
        </>
      )}
    </div>
  );
}

export default AdminAnalyticsFilter;
